export default __webpack_public_path__ + "static/media/TinDog.ae5c9cb5.jpg";